import React from 'react';
import { Box, Slider, Typography } from '@mui/material';
import Card from './Card';
import SectionHeader from './SectionHeader';
import { withLanguage } from '../common/Texts';
import { dashboardTokens as t } from './tokens';

const MARKS = [
    { value: 0, label: 'now' },
    { value: 4, label: '4' },
    { value: 7, label: '7' },
    { value: 10, label: '10' },
    { value: 15, label: '15' },
    { value: 20, label: '20' },
];

export default function AgeSlider({ language, value, onChange }) {
    const tr = withLanguage(language);
    const marks = MARKS.map((m) => ({
        value: m.value,
        label: m.value === 0 ? (tr('current') || 'Now') : m.label,
    }));

    return (
        <Card>
            <SectionHeader
                title={tr('estimated_increase') || 'Projected Growth'}
                action={
                    <Typography sx={{
                        fontSize: 13,
                        fontWeight: 600,
                        color: t.color.primary,
                        backgroundColor: t.color.primarySoft,
                        border: `1px solid ${t.color.primaryBorder}`,
                        borderRadius: `${t.radius.sm}px`,
                        px: 1.25,
                        py: 0.5,
                        minWidth: 56,
                        textAlign: 'center',
                    }}>
                        {value === 0 ? (tr('current') || 'Now') : `+${value}y`}
                    </Typography>
                }
            />
            <Box sx={{ px: 1.5, pt: 1 }}>
                <Slider
                    value={value}
                    onChange={onChange}
                    min={0}
                    max={20}
                    step={null}
                    marks={marks}
                    valueLabelDisplay="auto"
                    valueLabelFormat={(v) => (v === 0 ? (tr('current') || 'Now') : `+${v}y`)}
                    aria-label={tr('estimated_increase')}
                    sx={{
                        color: t.color.primary,
                        height: 6,
                        '& .MuiSlider-rail': { opacity: 1, backgroundColor: t.color.divider },
                        '& .MuiSlider-track': { border: 'none' },
                        '& .MuiSlider-thumb': {
                            height: 18,
                            width: 18,
                            backgroundColor: t.color.surface,
                            border: `2px solid ${t.color.primary}`,
                            boxShadow: t.shadow.sm,
                            '&:focus, &:hover, &.Mui-active': {
                                boxShadow: `0 0 0 6px ${t.color.primarySoft}`,
                            },
                        },
                        '& .MuiSlider-mark': {
                            height: 8,
                            width: 2,
                            backgroundColor: t.color.fgFaint,
                        },
                        '& .MuiSlider-markActive': { backgroundColor: t.color.primary },
                        '& .MuiSlider-markLabel': {
                            fontSize: 12,
                            color: t.color.fgMuted,
                        },
                    }}
                />
            </Box>
        </Card>
    );
}
